import { DeliveryPricing, DeliveryType } from 'src/api/@generated/backend-api';

import { getOrThrow } from './type-utils';

const getDeliveryPrice = (deliveryPricings: DeliveryPricing[], deliveryType: DeliveryType) => {
  const deliveryPrice = deliveryPricings.find((value) => value.deliveryType === deliveryType);

  return getOrThrow(deliveryPrice?.price, `Could not find delivery price for type ${deliveryType}`);
};

export const PricingUtils = {
  getDeliveryPrice,
};
